import { Injectable }    from '@angular/core';
import { Headers, Http } from '@angular/http';
import { InterceptorService } from 'ng2-interceptors';
import { SubscriptionModel } from '../entity/subscription-model';
import { Subscription } from '../entity/subscription';
import 'rxjs/add/operator/toPromise';


@Injectable()
export class SubscriptionService {

  private headers = new Headers({'Content-Type': 'application/json'});

  constructor(private http: InterceptorService) { }

  getSubscriptionModels(): Promise<any> {
    let subscriptions = [];
    let subscription0 = new SubscriptionModel();
    subscription0.code="120";
    subscription0.title="Analyses sur lait de Tank"
    subscription0.subtitle="Analyses systèmatiques";
    subscription0.duration="1 an";
    subscription0.parameters=["Cellules leucocytaires", "MG", "MP", "Cellules", "Lipolyse", "Urée", "Lactose"];
    subscription0.resultDelay="J+2 max | par mail";
    subscription0.collectDetail="Dépôt soit directement au laboratoire, soit à la laiterie";
    subscription0.description="Réalisation d’analyses systématiques à chaque enlèvement sur l'échantillon interprofessionnel, hors analyses effectuées dans le cadre du paiement du lait."
    subscription0.pricing="3,00 € HT/échantillon";
    subscription0.frequency = "1 fois/an"
    subscriptions[subscriptions.length] = subscription0;

    let subscription1 = new SubscriptionModel();
    subscription1.code="121";
    subscription1.title="Analyses sur lait de Tank"
    subscription1.subtitle="Analyses systèmatiques";
    subscription1.duration="1 an";
    subscription1.parameters=["Cellules leucocytaires"];
    subscription1.resultDelay="J+2 max | par mail";
    subscription1.collectDetail="Dépôt soit directement au laboratoire, soit à la laiterie";
    subscription1.description="Réalisation d’analyses systématiques à chaque enlèvement sur l'échantillon interprofessionnel, hors analyses effectuées dans le cadre du paiement du lait."
    subscription1.pricing="0,60 € HT/échantillon";
    subscription1.frequency = "-";
    subscriptions[subscriptions.length] = subscription1;

    let subscription2 = new SubscriptionModel();
    subscription2.code="122";
    subscription2.title="Analyses sur lait de Tank";
    subscription2.subtitle="Analyses systèmatiques";
    subscription2.duration="1 an";
    subscription2.parameters=["MG", "MP", "Cellules leucocytaires"];
    subscription2.resultDelay="J+2 max | par mail";
    subscription2.collectDetail="Dépôt soit directement au laboratoire, soit à la laiterie";
    subscription2.description="Réalisation d’analyses systématiques à chaque enlèvement sur l'échantillon interprofessionnel, hors analyses effectuées dans le cadre du paiement du lait.";
    subscription2.pricing="1,20 € HT/échantillon";
    subscription2.frequency = "-";
    subscriptions[subscriptions.length] = subscription2;

    let subscription3 = new SubscriptionModel();
    subscription3.code="123";
    subscription3.title="Analyses sur lait de Tank";
    subscription3.subtitle="Analyses systèmatiques";
    subscription3.duration="1 an";
    subscription3.parameters=["MG", "MP", "Cellules leucocytaires", "Lipolyse", "Urée"];
    subscription3.resultDelay="J+2 max | par mail";
    subscription3.collectDetail="Dépôt soit directement au laboratoire, soit à la laiterie";
    subscription3.description="Réalisation d’analyses systématiques à chaque enlèvement sur l'échantillon interprofessionnel, hors analyses effectuées dans le cadre du paiement du lait.";
    subscription3.pricing="2,50 € HT/échantillon";
    subscription3.frequency = "-";
    subscriptions[subscriptions.length] = subscription3;

    let subscription4 = new SubscriptionModel();
    subscription4.code="124";
    subscription4.title="Analyses sur lait de Tank";
    subscription4.subtitle="Analyses mensuelles";
    subscription4.duration="1 an";
    subscription4.parameters=["MG", "MP", "Urée", "Acides gras (7 paramètres)"];
    subscription4.resultDelay="J+2 max | par mail";
    subscription4.collectDetail="Dépôt soit directement au laboratoire, soit à la laiterie";
    subscription4.description="Réalisation d’analyses systématiques à chaque enlèvement sur l'échantillon interprofessionnel, hors analyses effectuées dans le cadre du paiement du lait.";
    subscription4.pricing="5,97 € HT/Echantillon";
    subscription4.frequency = "1 fois/mois";
    subscriptions[subscriptions.length] = subscription4;

    let subscription5 = new SubscriptionModel();
    subscription5.code="125";
    subscription5.title="Analyses d’eau";
    subscription5.subtitle="Analyses EAU 5 paramètres";
    subscription5.duration="1 an";
    subscription5.parameters=["Potentiel en Hydrogène", "Nitrates", "Coliformes", "Escherichia coli", "Entérocoques intestinaux"];
    subscription5.resultDelay="J+5 max | par mail";
    subscription5.collectDetail="Dépôt soit directement au laboratoire, soit à la laiterie";
    subscription5.description="Réalisation d’une analyse annuelle d’eau issue de captage privé, prélevée par vos soins.";
    subscription5.pricing="34,00 € HT";
    subscription5.frequency = "-";
    subscriptions[subscriptions.length] = subscription5;

    let subscription6 = new SubscriptionModel();
    subscription6.code="126";
    subscription6.title="Analyses sur lait individuel";
    subscription6.subtitle="Détection des germes à mammites";
    subscription6.duration="-";
    subscription6.parameters=["Détection de germes"];
    subscription6.resultDelay="J+7 (délai indicatif) | par mail";
    subscription6.collectDetail="Dépôt soit directement au laboratoire, soit à la laiterie";
    subscription6.description="Réalisation d’analyses en spectrométrie de masse, réalisées sur des échantillons de lait individuel de vache prélevés par vos soins. Protocole de prélèvement spécifié dans mode opératoire.";
    subscription6.pricing="43,50 € HT par série de 3 échantillons";
    subscription6.frequency = "-";
    subscriptions[subscriptions.length] = subscription6;

    return Promise.resolve(subscriptions);
  }

  public getSubscriptionModelByCode(code): Promise<any> {
    return this.http.get('http://dev.rhsi.local/site-api/subscriptions/model/'+code)
               .toPromise()
               .then(
                  function(response) {
                    let response_obj = response.json();
                    let subscriptionModel = new SubscriptionModel();
                    subscriptionModel.fromJSON(response_obj);
                    return {subscriptionModel};
                  }
                )
               .catch(this.handleError);
  }

  // public createSubscriptionFromModel(model: SubscriptionModel): Subscription {
  //   let subscription = new Subscription();
  //   subscription.code = model.code;
  //   subscription.title = model.title;
  //   subscription.count = model.count;
  //   subscription.duration = model.duration;
  //   subscription.startDate = model.startDate;
  //   subscription.endDate = model.endDate;
  //   subscription.isNotifyIdentification = model.isNotifyIdentification;
  //   subscription.isSendKit = model.isSendKit;
  //   subscription.sendKitDelay = model.sendKitDelay;
  //   subscription.isRenewal = model.isRenewal;
  //   subscription.isNotifyLaboratory = model.isNotifyLaboratory;
  //   subscription.notifyLaboratoryDelay = model.notifyLaboratoryDelay;
  //   subscription.samplesNumber = model.samplesNumber;
  //   subscription.parentSubscription = model.parentSubscription;
  //   subscription.thirdPartyApplicant = model.thirdPartyApplicant;
  //   subscription.thirdPartyOwner = model.thirdPartyOwner;

  //   return subscription;
  // }


  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }
}


// WEBPACK FOOTER //
// ./src/app/subscription/subscription.service.ts